var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-carousel',{staticClass:"slider",attrs:{"height":"560","hide-delimiter-background":""}},_vm._l((this.$store.state.sliders),function(item,index){return _c('v-carousel-item',{key:index,attrs:{"src":_vm.uploadPath('/sliders/'+item.avatar),"reverse-transition":"fade-transition","transition":"fade-transition","cycle":"cycle"}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }